<div class="header">
    <media-image [media]="data.item"></media-image>
    <div class="meta">
        <a class="primary-name hover-underline" [routerLink]="urls.album(data.item)">{{data.item.name}}</a>
        <a class="secondary-name hover-underline" [routerLink]="urls.artist(data.item.artist)">{{data.item.artist.name}}</a>
    </div>
</div>

<div class="context-menu-panel primary-panel" [class.hidden]="!activePanelIs('primary')">
    <div class="panel-body">
        <div class="context-menu-item" (click)="addToQueue()" trans>Add to Queue</div>
        <div class="context-menu-item" (click)="openPanel('playlist'); $event.stopPropagation()"><span trans>Add to Playlist</span> <mat-icon svgIcon="keyboard-arrow-right"></mat-icon></div>
        <div class="context-menu-item" *ngIf="inLibrary()" (click)="removeFromLibrary()" trans>Remove from Your Music</div>
        <div class="context-menu-item" *ngIf="!inLibrary()" (click)="saveToLibrary()" trans>Add to Your Music</div>
        <div class="context-menu-item" (click)="copyLinkToClipboard()" trans>Copy Album Link</div>
        <div class="context-menu-item" (click)="openShareModal()" trans>Share</div>
        <a class="context-menu-item"  [routerLink]="editAlbumUrl" *ngIf="canEditAlbum('albums.update')" trans>Edit</a>
        <div class="context-menu-item" (click)="maybeDeleteAlbum()" *ngIf="canEditAlbum('albums.delete')" trans>Delete</div>
    </div>
</div>

<context-menu-playlist-panel class="context-menu-panel" [class.hidden]="!activePanelIs('playlist')" [tracks]="getTracks()" (close$)="openPanel('primary')"></context-menu-playlist-panel>
